export const redirectManager = {
  persistRedirectUrl: (url: string | undefined) => {
    if (url) {
      sessionStorage.setItem('redirect', url);
    } else {
      sessionStorage.removeItem('redirect');
    }
  },
  redirectIfApplicable: () => {
    const redirectUrl = sessionStorage.getItem('redirect');
    sessionStorage.removeItem('redirect');
    if (redirectUrl && redirectUrl.startsWith(window.location.origin)) {
      window.location.href = redirectUrl;
    }
  }
};
